


export default function PaymentSuccess(){


    return(
        <div className="popup-bg">
        <div className="popup-window bg-white p-8 flex flex-col gap-3 items-center max-w-md">
            <img className="h-24" alt="logo" src="/iconslimsvet/logo.png" />
            <p className="font-medium text-dark-green text-md text-center">Votre transaction a été traitée avec succès. Votre demande d'analyses est en cours de traitement par le laboratoire.</p>
        </div>
    </div>
    );
}